import {
  ThemePerformanceSortHorizon,
  ThemeTimeseriesV5Response,
  themeOverview,
} from '@api';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_GET_V5_THEME_PERFORMANCE_TIMESERIES =
  'QUERY_KEY_GET_V5_THEME_PERFORMANCE_TIMESERIES';

export const useThemePerformanceTimeseries = (
  {
    themeId,
    horizon,
  }: {
    themeId: string;
    horizon: ThemePerformanceSortHorizon;
  },
  enabled = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_GET_V5_THEME_PERFORMANCE_TIMESERIES, themeId, horizon],
    queryFn: ({ signal }) =>
      wretchRequest<ThemeTimeseriesV5Response>(
        themeOverview.getV5ThemePerformanceTimeseries.path({
          themeId,
          horizon,
        }),
        {
          schema: themeOverview.getV5ThemePerformanceTimeseries.schema,
          options: { signal },
        }
      ),
    enabled,
  });
